"use client";

import { BSRDownload } from "./bsr/BSRDownload";
import { createBSRExperimentIcon } from "./createBSRExperimentIcon";
import { Download as LegacyDownload } from "./legacy/Download";

export const Download = createBSRExperimentIcon(LegacyDownload, BSRDownload);
